import { Injectable, EventEmitter } from '@angular/core';
import { Http, Headers, Response, RequestOptionsArgs } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';
import { environment } from '../../environments/environment';

@Injectable()
export class HttpAuth {
  event: EventEmitter<String> = new EventEmitter<String>();

  constructor(private http: Http,
    private auth: AuthService,
    private router: Router,
    public configurationService: ConfigurationService
  ) {}

  createRequestHeaders(headers: Headers) {
    headers.set('Content-Type', 'application/json');
    headers.set('X-API-KEY', environment.apiKey);

    if (this.auth.authenticated()) {
      headers.set('X-ACCESS-TOKEN', this.auth.idToken);
    }
  }

  public get(url: string, options?: RequestOptionsArgs) {
    let headers = new Headers();
    this.createRequestHeaders(headers);

    if(options === undefined) {
      options = {headers: headers};
    } else {
      options.headers = headers;
    }

    return this.authIntercept(this.http.get(url, options))
      .map(res => {
        let body = res.json();
        if (body.auth) {
          this.configurationService.changeConfiguration(body.auth);
        }
        return res;
      });
      // .retryWhen(errors => errors);
  }

  public post(url: string, data: any, options?: RequestOptionsArgs) {
    let headers = new Headers();
    this.createRequestHeaders(headers);

    if(options === undefined) {
      options = {headers: headers};
    } else {
      options.headers = headers;
    }

    return this.authIntercept(this.http.post(url, data, options))
    .map(res => {
      let body = res.json();
      if (body.auth) {
        this.configurationService.changeConfiguration(body.auth);
      }
      return res;
    });
}

  public put(url: string, data: any, options?: RequestOptionsArgs) {
    let headers = new Headers();
    this.createRequestHeaders(headers);

    if(options === undefined) {
      options = {headers: headers};
    } else {
      options.headers = headers;
    }

    return this.authIntercept(this.http.put(url, data, options))
    .map(res => {
      let body = res.json();
      if (body.auth) {
        this.configurationService.changeConfiguration(body.auth);
      }
      return res;
    });
}

  public delete(url: string, options?: RequestOptionsArgs) {
    let headers = new Headers();
    this.createRequestHeaders(headers);

    if(options === undefined) {
      options = {headers: headers};
    } else {
      options.headers = headers;
    }

    return this.authIntercept(this.http.delete(url, options))
    .map(res => {
      let body = res.json();
      if (body.auth) {
        this.configurationService.changeConfiguration(body.auth);
      }
      return res;
    });
}

  //noinspection JSMethodCanBeStatic
  private isUnauthorized(status: number): boolean {
    return status === 401;
  }

  //noinspection JSMethodCanBeStatic
  private isStatusZero(status: number): boolean {
    return status === 0;
  }

  private authIntercept(response: Observable<Response>): Observable<Response> {
    let sharableResponse = response.share();
    sharableResponse.subscribe(
      (data) => {
        this.onNotStatusZeroEvent();
      },
      (err) => {
        if (this.isUnauthorized(err.status)) {
          this.auth.logout();
          //noinspection JSIgnoredPromiseFromCall
          this.router.navigate(['/login']);
        } else {
          if (this.isStatusZero(err.status)) {
            this.onStatusZeroEvent();
          } else  {
            this.onNotStatusZeroEvent();
          }
        }
        // Other error handling may be added here, such as refresh token
      }
    );

    return sharableResponse;
  }

  onStatusZeroEvent() {
    this.configurationService.changeErrorHttp(true);
  }

  onNotStatusZeroEvent() {
    this.configurationService.changeErrorHttp(false);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/http-auth.service.ts